import React, { useState, useEffect } from 'react';
import styles from './ContactTypes.module.css';

const ContactTypeForm = ({ contactType, onSubmit, onCancel, loading }) => {
    const [formData, setFormData] = useState({
        contactType: '',
        description: ''
    });
    
    const [errors, setErrors] = useState({});

    // Initialize form with existing data when editing
    useEffect(() => {
        if (contactType) {
            setFormData({
                contactType: contactType.contactType || '',
                description: contactType.description || ''
            });
        }
    }, [contactType]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.contactType || formData.contactType.trim().length === 0) {
            newErrors.contactType = 'Contact type name is required';
        }

        if (formData.contactType.length > 50) {
            newErrors.contactType = 'Contact type name cannot exceed 50 characters';
        }

        if (formData.description && formData.description.length > 254) {
            newErrors.description = 'Description cannot exceed 254 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit(formData);
        }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formHeader}>
                <h3>{contactType ? 'Edit Contact Type' : 'Add New Contact Type'}</h3>
            </div>
            <div className={styles.formBody}>
                <div className={styles.field}>
                    <label className={styles.label}>Contact Type Name *</label>
                    <input
                        type="text"
                        value={formData.contactType}
                        onChange={(e) => setFormData({
                            ...formData,
                            contactType: e.target.value
                        })}
                        className={`${styles.input} ${errors.contactType ? styles.inputError : ''}`}
                        placeholder="Enter contact type name (e.g., Billing, Reporting, Support)"
                        maxLength={50}
                        disabled={loading}
                    />
                    {errors.contactType && (
                        <span className={styles.errorText}>{errors.contactType}</span>
                    )}
                    <small className={styles.hint}>
                        {formData.contactType.length}/50 characters
                    </small>
                </div>
                <div className={styles.field}>
                    <label className={styles.label}>Description</label>
                    <textarea
                        value={formData.description}
                        onChange={(e) => setFormData({
                            ...formData,
                            description: e.target.value
                        })}
                        className={`${styles.textarea} ${errors.description ? styles.inputError : ''}`}
                        placeholder="Enter description (optional)"
                        maxLength={254}
                        rows={4}
                        disabled={loading}
                    />
                    {errors.description && (
                        <span className={styles.errorText}>{errors.description}</span>
                    )}
                    <small className={styles.hint}>
                        {formData.description.length}/254 characters
                    </small>
                </div>
            </div>
            <div className={styles.formFooter}>
                <button 
                    type="button"
                    onClick={onCancel}
                    className={styles.cancelButton}
                    disabled={loading}
                >
                    Cancel
                </button>
                <button 
                    type="submit"
                    className={styles.submitButton}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : (contactType ? 'Update' : 'Create')}
                </button>
            </div>
        </form>
    );
};

export default ContactTypeForm;
